export enum AssessmentsColumnEnum {
	Name = 'name',
	Type = 'type',
	Status = 'status',
	DataSources = 'dataSources',
	ReviewDate = 'reviewDate',
	DataSubjects = 'dataSubjects',
	BusinessUnit = 'businessUnit',
	Collaborators = 'collaborators',
	Labels = 'labels',
	Owner = 'owner',
}

export enum AssessmentsTemplatesColumnEnum {
	Name = 'name',
	Type = 'type',
	Labels = 'labels',
	CreatedBy = 'createdBy',
	UpdatedBy = 'updatedBy',
}

export enum AssessmentFilteringGroupEnum {
	Type = 'type',
	Status = 'status',
	ReviewDate = 'reviewDate',
	DataSource = 'dataSource',
	DataRole = 'dataRole',
	DataSubject = 'dataSubject',
	BusinessUnit = 'businessUnit',
	BusinessOwner = 'businessOwner',
	Collaborators = 'collaborators',
	HasCollabInvites = 'hasCollabInvites',
	Labels = 'labels',
	Owner = 'owner',
	Creator = 'creator',
}

export enum AssessmentFilteringCategoryEnum {
	All = 'All',
	Draft = 'Draft',
	Shared = 'Shared',
	Submitted = 'Submitted',
	Completed = 'Completed',
	CollabCompleted = 'CollabCompleted',
	Due = 'Due',
	Labels = 'labels',
	Creator = 'creator',
	InProgress = 'InProgress',
	Rejected = 'Reject',
	NoResponse = 'NoResponse',
	PartialResponse = 'PartialResponse',
	ReadyForReview = 'ReadyForReview',
}

export enum AssessmentsActionsEnum {
	Approve = 'Approve',
	CreateAssessment = 'CreateAssessment',
	Clone = 'Clone',
	Delete = 'Delete',
	Edit = 'Edit',
	Export = 'Export',
	MarkAsDraft = 'Mark as draft',
	ViewVersionHistory = 'View version history',
	ViewAuditLog = 'View activity log',
	MoveUp = 'MoveUp',
	MoveDown = 'MoveDown',
	MoveToSection = 'MoveToSection',
	DeleteEvidence = 'DeleteEvidence',
	HideFromCollaborators = 'HideFromCollaborators',
	ShowToCollaborators = 'ShowToCollaborators',
	FlagRisk = 'FlagRisk',
	AddSectionOwner = 'AddSectionOwner',
	EditSectionOwner = 'EditSectionOwner',
	RemoveSectionOwner = 'RemoveSectionOwner',
	EditSection = 'EditSection',
}

export enum AssessmentTemplateTypeEnum {
	MineOS = 'MineOS',
	Custom = 'Custom',
}

export enum AssessmentTemplateModeEnum {
	Builder = 'Builder',
	Preview = 'Preview',
}

export enum AssessmentsExportFileFormatEnum {
	PDF = 'PDF',
	CSV = 'CSV',
	XLSX = 'XLSX',
}

export enum AgentBannerType {
	PreviewMode = 'PreviewMode',
	EditingMode = 'EditingMode',
	Shared = 'Shared',
	Submitted = 'Submitted',
}

export enum CollaboratorBannerType {
	PreviewMode = 'PreviewMode',
	EditingMode = 'EditingMode',
	Shared = 'Shared',
}

export enum AssessmentLogicOperandEnum {
	AND = 'AND',
	OR = 'OR',
}

export enum AssessmentLogicTypeEnum {
	HasSome = 'HasSome',
	HasExactly = 'HasExactly',
}

export enum AssessmentUseCaseEnum {
	AI = 'AI',
	Privacy = 'Privacy',
	Ropa = 'Ropa',
	Vendor = 'Vendor',
}

export enum UseCaseBySystemPageTab {
	AiGovernance = AssessmentUseCaseEnum.AI,
	Compliance = AssessmentUseCaseEnum.Privacy,
	VendorReview = AssessmentUseCaseEnum.Vendor,
}

export enum AssessmentsMenuAction {
	Export = 'Export',
}

export enum AssessmentCommentsFilterAction {
	FilterResolved = 'FilterResolved',
	FilterMentioned = 'FilterMentioned',
}

export enum AssessmentActivityLogsFilterAction {
	Person = 'Person',
}
